// ── Social & Community Configuration ─────────────────────────────────────────
// All URLs, handles, and counts live here. Update this file (or eventually
// drive it from the admin panel) without touching any page component.

export interface SocialPlatform {
  url: string;
  handle: string;
  description: string;
  cta: string;
  followerCount: number | null;
  videoCount: number | null;
}

export interface FeaturedVideo {
  id: string;
  title: string;
  duration: string;
  thumbnailUrl: string;
  youtubeUrl: string;
}

export interface TransformationPhoto {
  id: string;
  category: TransformationCategory;
  title: string;
  description: string;
  imageUrl: string;
  type: 'single' | 'before-after';
  beforeUrl?: string;
  afterUrl?: string;
}

export type TransformationCategory =
  | 'all'
  | 'playstation'
  | 'xbox'
  | 'nintendo'
  | 'steam-deck'
  | 'controllers'
  | 'computers';

export interface TransformationCategoryMeta {
  slug: TransformationCategory;
  label: string;
}

// ── Platform links ────────────────────────────────────────────────────────────

export const SOCIAL_PLATFORMS: Record<
  'youtube' | 'tiktok' | 'instagram' | 'facebook',
  SocialPlatform
> = {
  youtube: {
    url: 'https://www.youtube.com/@repaironwheels',
    handle: '@repaironwheels',
    description: 'Watch full repair walkthroughs, custom controller builds, and upgrade tutorials.',
    cta: 'Watch on YouTube',
    followerCount: null,  // populate when ready
    videoCount: null,
  },
  tiktok: {
    url: 'https://www.tiktok.com/@gamefixsolutions',
    handle: '@gamefixsolutions',
    description: 'Short satisfying clips: cleaning transformations, quick repairs, and shop life.',
    cta: 'Follow on TikTok',
    followerCount: null,
    videoCount: null,
  },
  instagram: {
    url: 'https://www.instagram.com/gamefixsolutions',
    handle: '@gamefixsolutions',
    description: 'Before & after photos, new controller builds, and special offers.',
    cta: 'Follow on Instagram',
    followerCount: null,
    videoCount: null,
  },
  facebook: {
    url: '',  // add URL when ready
    handle: '',
    description: 'Community updates, promotions, and customer shoutouts.',
    cta: 'Follow on Facebook',
    followerCount: null,
    videoCount: null,
  },
};

export const GOOGLE_BUSINESS = {
  locations: [
    { label: 'San Diego', url: 'https://share.google/jl29LJcRnhhdAP3Dm' },
    { label: 'Temecula',  url: 'https://maps.app.goo.gl/bbZsQWtNbftwZ3ZP8' },
  ],
  reviewCount: null,
  rating: null,
};

// ── Featured Videos ───────────────────────────────────────────────────────────
// Leave empty to show placeholder cards. Populate with real video data when
// connecting to the YouTube API, or add entries manually.

export const FEATURED_VIDEOS: FeaturedVideo[] = [];

// ── Transformation Photos ─────────────────────────────────────────────────────
// Leave empty to show placeholder cards. Add real entries as photos are taken.

export const TRANSFORMATION_PHOTOS: TransformationPhoto[] = [];

export const TRANSFORMATION_CATEGORIES: TransformationCategoryMeta[] = [
  { slug: 'all',         label: 'All' },
  { slug: 'playstation', label: 'PlayStation' },
  { slug: 'xbox',        label: 'Xbox' },
  { slug: 'nintendo',    label: 'Nintendo' },
  { slug: 'steam-deck',  label: 'Steam Deck' },
  { slug: 'controllers', label: 'Controllers' },
  { slug: 'computers',   label: 'Computers' },
];
